import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Popconfirm } from 'antd';

import { IconDelete, IconAdd } from '../../../../../../data/assets/icons';
import { BRAND_INFO } from '../../../../../../data/config/urls';

import InputItem from '../../../../../../components/form/inputitem';

class AddTeamMember extends Component {

    render() {
        const { new_team_members, onChangeEmail, onChangeFirstName, onChangeLastName, onClickDeleteMember, onClickAddMember } = this.props;

        return (
            <div className="ori-pad-15">
                <div className="ori-flex-column ori-flex-center ori-tb-pad-20 ">
                    <div className="ori-flex ori-height-40 ori-flex-center ">
                        <img src={BRAND_INFO.logo_url} alt="" className="ori-full-parent-height" />
                    </div>
                    <div className="ori-t-pad-10 ori-font-lg ">{`Invites members to ${BRAND_INFO.name}`}</div>
                </div>
                <div className="ori-tb-pad-10">
                    <Row gutter={8} className="ori-mobile-hidden ori-l-pad-10 ori-r-pad-30 ori-font-bold">
                        <Col xs={24} sm={8} className="ori-lr-pad-10" >
                            Email
                        </Col>
                        <Col xs={24} sm={8} className="ori-lr-pad-10">
                            First Name
                        </Col>
                        <Col xs={24} sm={8} className="ori-lr-pad-10">
                            Last Name
                        </Col>
                    </Row>
                    {
                        new_team_members && new_team_members.map((member, index) => {
                            return (
                                <div key={index} className="ori-animated ori-zoom-in ori-relative ori-bg-white ori-box-shadow ori-border-radius-4 ori-tb-pad-5 ori-l-pad-10 ori-r-pad-30  ori-tb-mrgn-5" >
                                    <Popconfirm overlayClassName="ori-zindex-99999" placement="topRight" title="Are you sure delete this member?" okText="Yes" cancelText="No" onConfirm={() => { onClickDeleteMember(index); }} >
                                        <div className="ori-absolute ori-pad-5 ori-align-right ori-align-top-7  ori-font-light-hover-primary">
                                            <IconDelete size={18} />
                                        </div>
                                    </Popconfirm>
                                    <Row gutter={8}>
                                        <Col xs={24} sm={8} >
                                            <InputItem type='email' placeholder="Enter Email" value={member.email} onChange={(e) => onChangeEmail(e.target.value, index)} />
                                        </Col>
                                        <Col xs={24} sm={8}>
                                            <InputItem placeholder="Enter First Name" value={member.firstName} onChange={(e) => onChangeFirstName(e.target.value, index)} />
                                        </Col>
                                        <Col xs={24} sm={8}>
                                            <InputItem placeholder="Enter Last Name" value={member.lastName} onChange={(e) => onChangeLastName(e.target.value, index)} />
                                        </Col>
                                    </Row>
                                </div>
                            );
                        })}
                </div>
                <div className="ori-cursor-ptr ori-font-primary" onClick={onClickAddMember}>
                    <IconAdd size={18} /><span className="ori-l-pad-5 ori-font-15">Add New Member</span>
                </div>
            </div>
        );
    }
}

AddTeamMember.propTypes = {
    new_team_members: PropTypes.array.isRequired,
    onChangeEmail: PropTypes.func,
    onChangeFirstName: PropTypes.func,
    onChangeLastName: PropTypes.func,
    onClickDeleteMember: PropTypes.func,
    onClickAddMember: PropTypes.func,
};

export default AddTeamMember;



// WEBPACK FOOTER //
// ./src/app/pagecontainer/modules/settings/teammembersetting/addteammember/index.js